export default __webpack_public_path__ + "static/media/point.d5054d37.png";